module.exports = __webpack_public_path__ + "static/media/user.e2d5f809.svg";